export default "__VITE_ASSET__Bbe0MiR5__";